var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/subscribe-ui-event/~/lodash/_Symbol.js
// module id = 363
// module chunks = 0